// PhoneInput.tsx
import React from "react"
import {useField} from "formik"
import Typography, {Variants} from "../../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"

const countries = [
	{code: "(+41)", label: "CH"},
	{code: "(+49)", label: "DE"},
	{code: "(+33)", label: "FR"},
	{code: "(+44)", label: "UK"},
	{code: "(+1)", label: "US"}
]

type PhoneInputProps = {
  name: string;
  labelStyle?: any;
  fontVariant?:keyof typeof Variants
  fieldHeight?: string;
}

const PhoneInput: React.FC<PhoneInputProps> = ({name, labelStyle, fieldHeight = "45px", fontVariant = "bodySmBoldMdBodyLgBold"}) => {
	const {t} = useTranslation()
	const [field, meta, helpers] = useField(name)
	const [countryCode, setCountryCode] = React.useState("(+41)")

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		helpers.setValue(`${countryCode} ${e.target.value}`)
	}

	const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		setCountryCode(e.target.value)
		const rawPhone = field.value.replace(/\(\+\d+\)\s*/, "")
		helpers.setValue(`${e.target.value} ${rawPhone}`)
	}

	return (
		<>
			<label htmlFor={name}
				className="text-left mb-2">
				<Typography variant={fontVariant}
					semanticTag="span">{t("phone-number")}</Typography>
				<span className="text-danger">*</span>
			</label>
			<div
				className={"d-flex border align-items-center"}
				style={{
					border: `1px solid ${meta.touched && meta.error ? "#dc3545" : "#f8f8f8"}`,
					borderRadius: "4px",
					overflow: "hidden",
					height: fieldHeight,
					background: "transparent"
				}}
			>
				<select
					value={countryCode}
					onChange={handleCountryChange}
					className="px-2 py-1 bg-transparent"
					style={{
						borderTop: "none",
						borderLeft: "none",
						borderBottom: "none",
						borderRight: "1px solid #DEE2E6",
						outline: "none",
						height: "100%"
					}}
				>
					{countries.map(c => (
						<option key={c.code}
							value={c.code}>
							{c.label} {c.code}
						</option>
					))}
				</select>
				<input
					type="tel"
					name={name}
					value={field.value.replace(`${countryCode} `, "")}
					onChange={handleChange}
					placeholder={t("phone-number")}
					className="flex-grow-1 px-2 py-1 border-0 bg-transparent"
					style={{outline: "none", height: "100%"}}
				/>
			</div>
			{meta.touched && meta.error && (
				<div className="text-danger ps-2 mt-1"
					style={{fontSize: "0.875rem"}}>
					{meta.error}
				</div>
			)}
		</>
	)
}

export default PhoneInput
